module.exports = __webpack_public_path__ + "static/media/logo2.5f68fae4.png";